import AdvanceTable from "components/common/advance-table/AdvanceTable";
import FalconPagination from "components/common/custom/pagination";
import IconButton from "components/common/IconButton";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { Gear, Pen } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";

const UserPermissionListTable = ({
  totalRows,
  handlePageChange,
  handlePerRowsChange,
  data,
  page,
  rowsPerPage,
}) => {
  const navigate = useNavigate();
  const columns = [
    {
      accessorKey: "index",
      sortable: true,
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center w-100">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "name",
      header: "Name ",
      sortabele: true,
      cell: ({ row: { original } }) => `${original?.syspri_name || ""}`,
    },
    {
      accessorKey: "action",
      header: <Gear />,
      cell: ({ row: { original } }) => (
        <IconButton
          variant="warning"
          size="sm"
          onClick={() =>
            navigate(`${paths.editPermission}/${original?.syspri_id}`)
          }
        >
          <Pen />
        </IconButton>
      ),
    },
  ];

  const table = useAdvanceTable({
    data,
    columns,
    sortable: true,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
  }, [page, rowsPerPage]);

  return (
    <div className="mb-3 mt-3 border">
      {data?.length > 0 ? (
        <div>
          <AdvanceTableProvider {...table}>
            <AdvanceTable
              tableProps={{
                size: "sm",
                className: "fs-10 mb-0 overflow-hidden",
                striped: true,
              }}
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
            />
          </AdvanceTableProvider>
          <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
            <FalconPagination
              currentPage={page}
              rowsPerPage={rowsPerPage}
              totalRecords={totalRows}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePerRowsChange}
            />
          </Card.Footer>
        </div>
      ) : (
        <div className="text-center py-3">No Data To Show</div>
      )}
    </div>
  );
};

export default UserPermissionListTable;
